import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
// import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import "../Gallery.css";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
const Loih2024 = () => {
  const numbers = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 
  ];
  // const i;
  var cTitle="Learning Outcome(In House)";
  const images = [
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/1.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/1.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/2.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/2.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/3.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/3.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/4.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/4.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/5.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/5.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/6.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/6.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/7.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/7.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/8.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/8.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/9.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/9.jpg",
    } ,
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/10.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/10.jpg",
    } ,
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/11.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/11.jpg",
    } ,
    {
      original: "http://www.mpsckp.com/gallery/loih_2024/12.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/loih_2024/12.jpg",
    } 
  ];

  // const listItems = numbers.map((number, index) => {

  //     return (

  //       [{

  //       }

  //     ]
  //     );

  // });
  // console.log(listItems);

  return (
    <div className="inner-body">
      <Container fluid>
        <Row className="inner">
          <div className="inner-head-outer">
            <div className="inner-head">
              <Col>
                <h2>{cTitle}</h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="../">
                    <i className="fa fa-home"></i> Home
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to={"/mgallery"}>
                      <i className="fa fa-camera"></i> Gallery
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>{cTitle}</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </div>
          </div>
        </Row>
      </Container>
      <div className="mib relative">
        <div className="leftline"></div>

        <div className="bottomline"></div>
        <Container>
          {/* <Gallery>{listItems}</Gallery> */}
          <Row>
            <Col>
              <ImageGallery items={images} lazyLoad={true}/>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Loih2024;
